import { MidPoint, Point, PointType } from "../../../types";

export interface GroupedPoints {
  pointType: PointType;
  points: Point[];
}

export const getPointsGrouped = (points: MidPoint[]): GroupedPoints[] => {
  if (points[0]?.pointType !== PointType.START)
    throw new Error(`getPointsGrouped | first point must have pointType === PointType.START}`);
  if (points[points.length - 1]?.pointType !== PointType.END)
    throw new Error(`getPointsGrouped | last point must have pointType === PointType.END`);

  return points.reduce<GroupedPoints[]>((acc, val, i) => {
    // if first point..
    if (val.pointType === PointType.START) {
      // return value point with next point's type
      const firstMidPointType = points[i + 1]?.pointType;
      if (firstMidPointType) return [{ pointType: firstMidPointType, points: [{ x: val.x, y: val.y }] }];
      // if next point doesn't exist, return default as angle with current point..
      else return [{ pointType: PointType.ANGLE, points: [{ x: val.x, y: val.y }] }];
    }

    // get latest point group
    const latestPointGroup = acc[acc.length - 1];
    // if curr val type is same as latest point group..
    if (val.pointType === latestPointGroup?.pointType) {
      // return latest adding the current to latest points
      return [
        ...acc.slice(0, -1),
        { ...latestPointGroup, points: [...latestPointGroup.points, { x: val.x, y: val.y }] },
      ];
    }

    // else, curr val type is NOT same as latest point group..
    else {
      switch (val.pointType) {
        // if new CURVE group..
        case PointType.CURVE: {
          const lastPointInLatestPointGroup = latestPointGroup?.points[latestPointGroup?.points?.length - 1];
          // return with new CURVE point group, pulling in last group's last point
          if (!lastPointInLatestPointGroup) return acc;
          return [
            ...acc,
            {
              pointType: val.pointType,
              points: [lastPointInLatestPointGroup, { x: val.x, y: val.y }],
            },
          ];
        }

        // if new ANGLE group..
        case PointType.ANGLE: {
          if (!latestPointGroup) return acc;
          // return with new ANGLE point, pushing this values point into last CURVE's points
          return [
            ...acc.slice(0, -1),
            { ...latestPointGroup, points: [...(latestPointGroup?.points || []), { x: val.x, y: val.y }] },
            { pointType: val.pointType, points: [{ x: val.x, y: val.y }] },
          ];
        }

        // if END group
        case PointType.END: {
          if (!latestPointGroup) return acc;
          return [
            ...acc.slice(0, -1),
            {
              pointType: latestPointGroup?.pointType,
              points: [...(latestPointGroup?.points || []), { x: val.x, y: val.y }],
            },
          ];
        }

        default:
          return acc;
      }
    }
  }, []);
};
